import Vue from 'vue'
import App from './App.vue'
import router from './vue/router'
import store from './vue/store'
import {VueAxios} from '@/vue/utils/request'
import filters from './vue/utils/filters'
import filter from './utils/filter'
import bootstrap from './vue/utils/bootstrap'
import VueStorage from 'vue-ls'
import FastClick from 'fastclick'
const options = {
    namespace: 'ykry__',
    name: 'ls',
    storage: 'local',
};

Vue.prototype.baseUrl = 'http://api-credit.bjxzdc.com'
// Vue.prototype.baseUrl = 'http://web2.touus.com:7080'
// Vue.prototype.baseUrl = 'http://127.0.0.1:8080'

//处理IOS vant框架 dialog嵌套filed无法点击按钮的失焦问题
let windowScroll
const isiOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
if (isiOS) {
    document.body.addEventListener('focusout', () => { //软键盘收起的事件处理
        windowScroll = window.setTimeout(() => {
            window.scroll(0, 0)
        }, 100)
    })
    document.body.addEventListener('focusin', () => {
        //软键盘弹出的事件处理
        if (windowScroll !== undefined) {
            window.clearTimeout(windowScroll)
        }
    })
}


Vue.config.productionTip = false

import {
    Row,
    Col,
    NavBar,
    Icon,
    Cell,
    CellGroup,
    Loading,
    Button,
    Toast,
    Tabbar,
    TabbarItem,
    List,
    Checkbox,
    CheckboxGroup,
    Search,
    Popup,
    Picker,
    Tab,
    Tabs,
    Field,
    CollapseItem,
    Collapse,
    Lazyload,
    Uploader,
    Switch,
    RadioGroup,
    Radio,
    Dialog,
    Circle,
    DatetimePicker,
    Skeleton,
    ActionSheet,
    Step,
    Steps,
    PullRefresh,
    IndexBar,
    IndexAnchor,
    Form,
    Tag,
    NumberKeyboard,
    Calendar,
    Panel,
    NoticeBar,
    Stepper,
    Divider,
    Grid,
    GridItem,
    Area
} from 'vant'


Vue.use(Row).use(Col).use(Icon).use(Cell).use(CellGroup).use(Loading).use(Button).use(Toast)
    .use(Tabbar).use(TabbarItem).use(NavBar).use(List).use(Checkbox).use(CheckboxGroup).use(Search)
    .use(Picker).use(Popup).use(Field).use(Tab).use(Tabs).use(CollapseItem).use(Collapse).use(Lazyload).use(Uploader)
    .use(Switch).use(RadioGroup).use(Radio).use(Dialog).use(Circle).use(DatetimePicker).use(Skeleton).use(ActionSheet).use(Steps).use(Step).use(PullRefresh)
    .use(IndexBar).use(IndexAnchor).use(Form).use(Tag).use(NumberKeyboard).use(Calendar).use(Panel).use(NoticeBar).use(Stepper).use(Divider).use(Grid).use(GridItem)
    .use(Area)

import 'font-awesome/css/font-awesome.css'
import VueHtml5Editor from 'vue-html5-editor'

/*Vue.use(VueHtml5Editor, {})*/
Vue.use(VueHtml5Editor, {
    // 全局组件名称，使用new VueHtml5Editor(options)时该选项无效
    // global component name
    name: "vue-html5-editor",
    // 是否显示模块名称，开启的话会在工具栏的图标后台直接显示名称
    // if set true,will append module name to toolbar after icon
    showModuleName: false,
    // 自定义各个图标的class，默认使用的是font-awesome提供的图标
    // custom icon class of built-in modules,default using font-awesome
    icons: {
        text: "fa fa-pencil",
        color: "fa fa-paint-brush",
        font: "fa fa-font",
        align: "fa fa-align-justify",
        list: "fa fa-list",
        link: "fa fa-chain",
        unlink: "fa fa-chain-broken",
        tabulation: "fa fa-table",
        hr: "fa fa-minus",
        eraser: "fa fa-eraser",
        undo: "fa-undo fa",
        "full-screen": "fa fa-arrows-alt",
        info: "fa fa-info",
    },
    // 语言，内建的有英文（en-us）和中文（zh-cn）
    //default en-us, en-us and zh-cn are built-in
    language: "zh-cn",
    // 自定义语言
    i18n: {
        //specify your language here
        "zh-cn": {
            "align": "对齐方式",
            "image": "图片",
            "list": "列表",
            "link": "链接",
            "unlink": "去除链接",
            "table": "表格",
            "font": "文字",
            "full screen": "全屏",
            "text": "排版",
            "eraser": "格式清除",
            "info": "关于",
            "color": "颜色",
            "please enter a url": "请输入地址",
            "create link": "创建链接",
            "bold": "加粗",
            "italic": "倾斜",
            "underline": "下划线",
            "strike through": "删除线",
            "subscript": "上标",
            "superscript": "下标",
            "heading": "标题",
            "font name": "字体",
            "font size": "文字大小",
            "left justify": "左对齐",
            "center justify": "居中",
            "right justify": "右对齐",
            "ordered list": "有序列表",
            "unordered list": "无序列表",
            "fore color": "前景色",
            "background color": "背景色",
            "row count": "行数",
            "column count": "列数",
            "save": "确定",
            "upload": "上传",
            "progress": "进度",
            "unknown": "未知",
            "please wait": "请稍等",
            "error": "错误",
            "abort": "中断",
            "reset": "重置"
        }
    },
    // 隐藏不想要显示出来的模块
    // the modules you don't want
    hiddenModules: [],
    // 自定义要显示的模块，并控制顺序
    // keep only the modules you want and customize the order.
    // can be used with hiddenModules together
    visibleModules: [
        "text",
        "font",
        "align",
        "tabulation",
        "hr",
        "eraser",
        "undo",
        "full-screen",
    ],
    // 扩展模块，具体可以参考examples或查看源码
    // extended modules
    modules: {
        //omit,reference to source code of build-in modules
    }
})


// 挂载axios
Vue.use(VueAxios)

Vue.use(VueStorage, options)

Object.keys(filters).forEach(key => Vue.filter(key, filters[key]))

new Vue({
    router,
    store,
    created() {
        //刷新后初始化本地数据到vuex
        FastClick.attach(document.body)
        bootstrap()

    },
    render: h => h(App)
}).$mount('#app')
